// The message a buyer's phone types for them when they tap a tracked link.
export function prefilledText(projectName: string | null | undefined, code: string): string {
  return projectName ? `Hi, I'm interested in ${projectName}. Please share details. [${code}]` : `Hi, please share details. [${code}]`;
}

export function waLink(displayNumberE164: string, text: string): string {
  return `https://wa.me/${displayNumberE164.replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;
}

export const PLACEMENTS = ['Instagram post', 'Instagram story', 'Facebook post', 'WhatsApp Status', 'Broker group', 'Site poster (QR)', 'Website', 'Other'];
